import { render, staticRenderFns } from "./summarystats.vue?vue&type=template&id=6bb54d20&scoped=true"
import script from "./summarystats.vue?vue&type=script&lang=js"
export * from "./summarystats.vue?vue&type=script&lang=js"
import style0 from "./summarystats.vue?vue&type=style&index=0&id=6bb54d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb54d20",
  null
  
)

export default component.exports